import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const HomeBackupPage = lazy(() => import("../pages/home-backup/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const PrivacyPage = lazy(() => import("../pages/privacy/page"));
const TermsPage = lazy(() => import("../pages/terms/page"));
const HowItWorksPage = lazy(() => import("../pages/how-it-works/page"));
const WhoItsForPage = lazy(() => import("../pages/who-its-for/page"));
const GetStartedPage = lazy(() => import("../pages/get-started/page"));
const DemoLawnCarePage = lazy(() => import("../pages/demo-lawn-care/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/home-backup",
    element: <HomeBackupPage />,
  },
  {
    path: "/about-us",
    element: <AboutPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms-and-conditions",
    element: <TermsPage />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorksPage />,
  },
  {
    path: "/who-its-for",
    element: <WhoItsForPage />,
  },
  {
    path: "/get-started",
    element: <GetStartedPage />,
  },
  {
    path: "/legal-demo",
    element: <DemoLawnCarePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
